import React from 'react';
import { useVisibilityObserver } from '@noths/polaris-client-react-hooks';
import { visuallyHidden } from '@noths/polaris-client-styles';

import * as elementIds from 'src/components/organisms/Filter/constants/elementIds';
import { FilterOptionsContainer } from 'src/components/organisms/Filter/containers/FilterOptionsContainer';
import * as styles from 'src/components/organisms/Filter/styles/FilterList.styles';
import type { BrowseDataAPIFilter } from 'src/services/browse-data-api/types/BrowseDataAPIFilter';

const VISIBILITY_THRESHOLD = 0.7;

interface Props {
  filter: BrowseDataAPIFilter;
  onFilterListItemVisibility: (filterUid: string) => void;
}

export const FilterListItem = ({ filter, onFilterListItemVisibility }: Props) => {
  const { observedElementRef: listItemRef } = useVisibilityObserver<HTMLLIElement>(
    () => onFilterListItemVisibility(filter.uid),
    { observerOptions: { threshold: VISIBILITY_THRESHOLD }, autoUnobserve: true },
  );
  const activeOptionsCount = filter.options.filter((option) => option.active).length;

  return (
    <li css={styles.listItem} ref={listItemRef} data-testid={`listitem-${filter.title}`}>
      <h3 css={styles.filterHeading}>
        {filter.title}
        {activeOptionsCount > 0 && (
          <>
            <span data-testid={elementIds.FILTER_LIST_ITEM_COUNT} css={styles.filterCount}>
              {activeOptionsCount}
            </span>
            <span css={visuallyHidden}> selected</span>
          </>
        )}
      </h3>
      <FilterOptionsContainer key={filter.uid} filter={filter} />
    </li>
  );
};
